import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    background-color: #171850;
    padding: 100px 60px;
    text-align: center;

    @media (max-width: 1400px) {
        padding: 50px 0 40px 0;
    }
`

export const ContainerInterno = styled.div`
    display: inline-block;
    width: 1436px;
    max-width: 100%;
    margin: 0 auto;
`

export const TituloPrincipal = styled.span`
    float: left;
    width: 100%;
    color: #FFFFFF;
    font-size: 30px;
    line-height: 40px;
    font-weight: 900;
    margin: 0 0 15px 0;
    text-align: center;

    strong {
        color: #EFBD5E;
    }

    @media only screen and (max-width: 1400px) {
        padding: 0 20px;
    }

    @media (max-width: 768px) {
        font-size: 22px;
        line-height: 32px;
    }
`

export const Subtitulo = styled.span`
    float: left;
    width: 100%;
    color: #C3C9E6;
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    margin: 0 0 50px 0;
    text-align: center;

    @media only screen and (max-width: 1400px) {
        padding: 0 20px;
    }

    @media (max-width: 768px) {
        margin: 0 0 40px 0;
    }
`

export const ListaConteudos = styled.div`
    float: left;
    width: 100%;
    overflow: auto;
`

export const ListaConteudosScroll = styled.div`
    float: left;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    padding-top: 20px;
    padding-bottom: 20px;

    @media only screen and (max-width: 1400px) {
        width: 1200px;
        margin: 0 15px;
        direction: rtl;
    }
`

export const ListaConteudosItem = styled.div`
    display: flex;
    align-items: flex-end;

    @media only screen and (max-width: 1400px) {
        
    }
`

export const ListaConteudosItemInterno = styled.div`
    padding: 30px 0 0 0;
    float: left;
    width: 100%;
    border: ${ props => props.premium ? 'none' : 'solid 1px #FAFAFA' };
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: ${props => props.premium ? 'linear-gradient(90deg,rgba(189, 137, 59, 1) 0%, rgba(239, 189, 94, 1) 100%)' : 'linear-gradient(90deg,rgba(46, 46, 46, 1) 0%, rgba(118, 118, 118, 1) 100%)'};
    position: relative;

    &.item1 {
        padding: 60px 0 0 0;
    }

    &.item2 {
        padding: 50px 0 0 0;
    }

    &.item3 {
        padding: 120px 0 0 0;
    }
`

export const ListaConteudosItemTagMelhor = styled.span`
    position: absolute;
    background-color: #FAFAFA;
    color: #191919;
    top: -15px;
    width: 60%;
    height: 30px;
    font-size: 13px;
    font-weight: 800;
    border-radius: 8px;
    left: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
`

export const ListaConteudosItemTitulo = styled.span`
    float: left;
    width: 100%;
    margin: 0;
    padding: 0;
    color: #FAFAFA;
    font-weight: 700;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    padding: 0 20px;
    font-size: 18px;
    line-height: 20px;
`

export const ListaConteudosItemPorcentagem = styled.span`
    float: left;
    margin: 5px 0;
    padding: 0 20px;
    width: 100%;
    color: #FAFAFA;
    text-align: center;
    font-size: 60px;
    line-height: 60px;
    font-weight: 900;

    small {
        font-size: 12px;
        line-height: 12px;
    }
`

export const ListaConteudosItemLegendaPorcentagem = styled.span`
    float: left;
    width: 100%;
    text-align: center;
    color: #FAFAFA;
    font-size: 14px;
    margin: 0 0 40px 0;
`

export const ListaConteudosItemMesesBonus = styled.span`
    float: left;
    width: 100%;
    color: #FAFAFA;
    text-align: center;
    padding: 0 20px 15px 20px;
    border-bottom: solid 1px #FAFAFA;
    font-size: 15px;
    font-weight: 700;
    line-height: 25px;

    &.item2 {
        border-color: #8a8989;
    }

    &.item3 {
        border-color: #8a8989;
    }
`

export const ListaConteudosItemMentoria = styled.span`
    float: left;
    width: 100%;
    color: #FAFAFA;
    text-align: center;
    padding: 15px 20px 15px 20px;
    border-bottom: solid 1px #FAFAFA;
    font-size: 15px;
    line-height: 25px;
    font-weight: 700;

    &.item2 {
        border-color: #8a8989;
    }

    &.item3 {
        border-color: #8a8989;
    }
`

export const ListaConteudosItemMesesAcesso = styled.span`
    float: left;
    width: 100%;
    color: #FAFAFA;
    text-align: center;
    padding: 15px 20px 15px 20px;
    font-size: 20px;
    line-height: 30px;
    font-weight: 700;
`

export const BoxDataFim = styled.div`
    float: left;
    width: 100%;
    margin-top: 60px;
    display: flex;
    justify-content: center;

    @media only screen and (max-width: 768px) {
        margin-top: 30px;
        padding: 0 20px;
    }
`

export const BoxDataFimSpan = styled.span`
    background-color: #EDC748;
    color: #0F1A2A;
    font-weight: 900;
    font-size: 16px;
    padding: 15px 150px;
    letter-spacing: 0.5px;
    border-radius: 5px;

    @media only screen and (max-width: 768px) {
        padding: 12px 10px;
        width: 100%;
        text-align: center;
        letter-spacing: 0;
        font-size: 13px;
        line-height: 20px;
    }
`